import axios from "axios";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { endpoint: String, pkey: String, callbackUrl: String, accountNo: String, newPaymentNoUrl: String }

  connect() {
    initEzidebitInputs()
    this.initSignupAndPayNow()
    this.termsConfirmationToggled()
  }

  initSignupAndPayNow() {
    const pkey = this.pkeyValue
    const endpoint = this.endpointValue

    eziDebit.init(pkey, {
      submitAction: "SaveCustomer",
      submitButton: "payNowButton",
      beforeSubmitCallback: () => this.beforeSubmitToEzidebit(),
      submitCallback: (data) => this.submitSuccessCallback(data),
      submitError: (data) => this.displaySubmitError(data),
      customerReference: "systemReference", // In Ezidebit Online this is known as the Client Contract Ref. This is your reference for the customer
      customerLastName: "lastname",
      customerFirstName: "firstName", // If no first name is provided the customerLastName is assumed to be the Company Name
      customerAddress1: "address1",
      customerAddress2: "address2",
      customerSuburb: "suburb",
      customerState: "state",
      customerPostcode: "postcode",
      customerEmail: "email",
      customerMobile: "mobile",
      nameOnCard: "nameOnCard",
      cardNumber: "cardNumber",
      cardExpiryMonth: "expiryMonth",
      cardExpiryYear: "expiryYear",
      paymentAmount: "amount",
      paymentReference: "paymentReference"
    }, endpoint);
  }

  async beforeSubmitToEzidebit() {
    const newPaymentNoUrl = this.newPaymentNoUrlValue;

    try {
      const response = await axios.get(newPaymentNoUrl);
      const paymentNo = response.data.payment_no;

      if (paymentNo) {
        const paymentReference = `${paymentNo}-${this.accountNoValue}`;
        $("#paymentReference").val(paymentReference);
        return true;
      } else {
        return false;
      }
    } catch (error) {
      // Let Ezidebit JS handle missing payment no
      return false;
    }
  }

  submitSuccessCallback(data) {
    if (data["ErrorMessage"] != null) {
      this.displaySubmitError(data["ErrorMessage"])
    } else {
      let paymentData = data.Data

      Object.assign(paymentData, {
        amount: $("#amount").val(),
        payment_reference: $("#paymentReference").val(),
        masked_card_number: maskString($("#cardNumber").val())
      });
      this.createPaymentAndPaymentMethod(paymentData)
    }
  }

  displaySubmitError(data) {
    bootbox.alert({
      title: formatBootboxTitle(false, "Failed"),
      className: "failure-modal",
      message: data,
      callback: function() {
        enableSubmitButton("#payNowButton", "Sign Up & Pay Now")
      }
    })
  }

  createPaymentAndPaymentMethod(paymentData) {
    const url = this.callbackUrlValue
    const authenticityToken = $('input[name="authenticity_token"]').val();
    axios.post(url,
      { authenticity_token: authenticityToken, transaction: paymentData },
      { headers: { 'Accept': 'text/vnd.turbo-stream.html' } }
    )
    .then(response => {
      Turbo.renderStreamMessage(response.data);
    })
    .catch(error => {
      showErrorMessage(error);
    });
  }

  termsConfirmationToggled(e) {
    const checkbox = document.querySelector("#ezidebit-accept-terms");
    const payNowButton = document.querySelector("#payNowButton");

    if (!checkbox) {
      return; // Exit the function if the checkbox doesn't exist
    }

    // Enable or disable the button based on the checkbox state
    payNowButton.disabled = !checkbox.checked;
  }
}